<template lang="pug">
.root
  the-heading(:caption="'Aдминистративные панели сервисов'" :breadcrumbs="breadcrumbs")
  .container
    .main_block
      .serveses
        .item
          a(:href="'/dhra/control'" add target="_blank")
            .item_header
              img(src='../../assets/svg/cube.svg')
              span Webiomed.DHRA
            .item_value Система поддержки принятия врачебных решений
        .item
          a(:href="'/patientid/control'" add target="_blank")
            .item_header
              img(src='../../assets/svg/cube.svg')
              span Webiomed.PatientID
            .item_value Система регистрации деперсонифицированных данных пациентов
        .item
          a(:href="'/dataset/control'" add target="_blank")
            .item_header
              img(src='../../assets/svg/cube.svg')
              span Webiomed.DataSet
            .item_value Система сбора деперсонифицированных биомедицинских данных и производства дата-сетов на их основе
        .item
          a(:href="'/symptom-checker/control'" add target="_blank")
            .item_header
              img(src='../../assets/svg/cube.svg')
              span Webiomed.SymptomChecker
            .item_value Система определения подозрения на заболевания и группы риска на основе списка выявленных у пациента признаков (симптомов) при помощи «движка решающих правил»
        .item
          a(:href="'/dma/control'" add target="_blank")
            .item_header
              img(src='../../assets/svg/cube.svg')
              span Webiomed.DMA
            .item_value Система прямого доступа к моделям
        .item
          a(:href="'/gate/control'" add target="_blank")
            .item_header
              img(src='../../assets/svg/cube.svg')
              span Webiomed.Gate
            .item_value Система предоставления доступа пользователей к сервисам «webiomed»
        .item
          a(:href="'/nlp/control'" add target="_blank")
            .item_header
              img(src='../../assets/svg/cube.svg')
              span Webiomed.NLP
            .item_value Система извлечения признаков моделями из текста
  //- the-footing
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import breadcrumbs from '@/data/breadcrumbs/AdminPannel'
import TheFooting from '@/components/parts/TheFooting'

export default {
  components: {
    TheHeading,
    TheFooting,
    breadcrumbs
  },
  data () {
    return {
      breadcrumbs
    }
  }
}
</script>
<style lang="sass" scoped>

@import "@/css/ChangeStateStyles.sass"

.serveses
  display: grid
  grid-template-columns: 45% 45%
  column-gap: 10%
  margin: 5vw 15vh
.item_header span
  font-family: Roboto
  font-style: normal
  font-weight: bold
  font-size: 25px
  line-height: 35px
  color: #414141
.serveses .item
  margin: 30px 15px

.item_header
  padding: 5px 40px
  display: inline-flex
  justify-content: center
  align-items: center
.item_header img
  padding-right: 20px
.item_value
  border-top: 3px solid #C4C4C4
  font-family: Roboto
  font-style: normal
  font-weight: bold
  font-size: 16px
  line-height: 23px
  text-align: center
  color: #414141
  padding: 5px 15px 0 15px

a
  text-decoration: none

.mini-header
  font-size: 17px
  font-weight: 450
  margin-top: 20px
.fields .mini-header
  margin-bottom: 20px

.radio
  margin-top: 20px
  margin-left: 35px
  font-size: 17px
.radio .item label
  cursor: pointer
.radio .item label:hover
  color: #404040
.radio .item:not(:last-child)
  margin-bottom: 10px

.text
  margin-top: 20px
  margin-bottom: 10px
  margin-left: 35px
  font-weight: bold
.text span
  font-weight: 400
</style>
